var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', {
    attrs: {
      "sh": "What We Do",
      "tabActive": "Safety Management",
      "bg": "/images/sub/visual/sv4.png"
    }
  }), _c('section', {
    staticClass: "sub-section sub-section--first"
  }, [_c('v-container', [_c('div', {
    staticClass: "page-tit-wrap"
  }, [_c('h2', {
    staticClass: "page-tit"
  }, [_vm._v(" Safety Management ")]), _c('p', [_vm._v(" We are establishing an occupational Health and Safety Management System for worker safety. "), _c('br'), _vm._v(" Consulting and requirements for periodic management of occupational safety management are being updated. ")])])])], 1), _c('section', {
    staticClass: "sub-section sub-section--last"
  }, [_c('v-container', [_c('sub-line-layout', {
    attrs: {
      "tit": "Safety Management System"
    }
  }, [_c('v-img', {
    staticClass: "mx-auto mb-90 mb-md-120 mb-lg-140 d-none d-lg-block",
    attrs: {
      "src": "/images/sub/wwd/management/management-img-en.png",
      "max-width": "950"
    }
  }), _c('v-img', {
    staticClass: "mx-auto mb-90 mb-md-120 mb-lg-140 d-block d-lg-none",
    attrs: {
      "src": "/images/sub/wwd/management/management-img-mo-en.png",
      "max-width": "480"
    }
  }), _c('v-row', {
    staticClass: "my-n10 my-lg-n40"
  }, [_c('sub-icon-box', {
    attrs: {
      "icon": "/images/sub/wwd/management/management-icon1.png",
      "iconWidth": "50",
      "tit": "Establishment and Maintenance of Safety & Health Management System"
    }
  }, [_c('p', {
    staticClass: "font-size-14 font-size-lg-16 color-grey-2c"
  }, [_vm._v(" Familiarity with the manual. "), _c('br'), _vm._v(" According to the company’s safety & health organization, business size and process characteristics ")])]), _c('sub-icon-box', {
    attrs: {
      "icon": "/images/sub/wwd/management/management-icon2.png",
      "iconWidth": "53",
      "tit": "Voluntary Industrial Accident Prevention"
    }
  }, [_c('p', {
    staticClass: "font-size-14 font-size-lg-16 color-grey-2c"
  }, [_vm._v(" Workers present their opinions on safety and health Identification of on-site risk factors, "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" establishment of improvement plans and confirmation of participation in operation of suggestions by workers ")])]), _c('sub-icon-box', {
    attrs: {
      "icon": "/images/sub/wwd/management/management-icon3.png",
      "iconWidth": "51",
      "tit": "Safety & Health Education and Training"
    }
  }, [_c('p', {
    staticClass: "font-size-14 font-size-lg-16 color-grey-2c"
  }, [_vm._v(" Safety and Health management system education for worker safety Identify items to "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" identify risk factors in the field. Action Priority decision, control and establishment of control plan. ")])]), _c('sub-icon-box', {
    attrs: {
      "icon": "/images/sub/wwd/management/management-icon4.png",
      "iconWidth": "54",
      "tit": "Safety and Health Related Laws Compliance with Requirements"
    }
  }, [_c('p', {
    staticClass: "font-size-14 font-size-lg-16 color-grey-2c"
  }, [_vm._v(" Serious Accident Punishment Act and Safety & Health Management System. "), _c('br'), _vm._v(" According to the purpose of construction, key factors and the need for implementation. "), _c('br'), _vm._v(" Establishment and implementation of work procedures for each key element. ")])])], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }